import React from 'react';
import { Paragraph, TextArea, tokens } from '@welbe/web-design-system';
import { useRiskConditions } from './RiskConditions.hooks';

export const RiskConditions = () => {
	const { actualConditions, recommendedActions, handleChange } =
		useRiskConditions();

	return (
		<div>
			<Paragraph fontSize="14px" fontWeight="400" color={tokens.color_primary}>
				Condiciones de riesgo actuales
			</Paragraph>
			<TextArea
				id="actualConditions"
				value={actualConditions}
				placeholder="Describe las condiciones de riesgo actuales"
				handleChange={(value) => handleChange('actualConditions', value)}
			/>
			<Paragraph
				fontSize="14px"
				fontWeight="400"
				padding="25px 0 0 0"
				color={tokens.color_primary}
			>
				Acciones preventivas y/o recomendaciones
			</Paragraph>
			<TextArea
				id="recommendedActions"
				value={recommendedActions}
				placeholder="Escribe un comentario"
				handleChange={(value) => handleChange('recommendedActions', value)}
			/>
		</div>
	);
};
